import axios from 'axios';

/**
 * Messaggio d'errore da mostrare all'utente.
 *
 * Le risposte di errore del backend includono sempre un campo `msg` (vedi
 * `sendError`/`sendBadRequest`): se presente lo si mostra così com'è, altrimenti
 * si ricade su un testo generico. Evita di ripetere lo stesso `catch` in ogni
 * punto che mostra un errore a schermo.
 */
export function errorMessage(err: unknown, fallback: string): string {
    if (axios.isAxiosError(err)) {
        const msg = (err.response?.data as { msg?: string } | undefined)?.msg;
        if (typeof msg === 'string' && msg.trim().length > 0) return msg;
    }
    return fallback;
}
